// eslint-disable-next-line import/no-cycle
import { getHomeMapPins, getIsHomeMapOpen } from '../../selectors/homeMapSelectors';

import {
  TRACK_TOGGLED_SHOW_MAP_VIEW,
  TRACK_TAPPED_PIN,
  TRACK_TAPPED_SEARCH_THIS_AREA,
} from './types';

export const trackToggledShowMapView = () => (dispatch, getState) => {
  const state = getState();
  const isOpen = getIsHomeMapOpen(state);
  return dispatch({
    type: TRACK_TOGGLED_SHOW_MAP_VIEW,
    payload: {
      name: 'Toggled show map view',
      properties: {
        // The flag isn't toggled yet, hence the negation.
        'Map view': !isOpen,
      },
    },
  });
};

export const trackTappedPin = (restaurantId) => ({
  type: TRACK_TAPPED_PIN,
  payload: {
    name: 'Tapped pin',
    properties: {
      'Pin type': 'restaurant',
      restaurant_id: parseInt(restaurantId, 10),
    },
  },
});

/**
 * To dispatch after the search query has returned so that the pins
 * in the state are up to date.
 */
export const trackTappedSearchThisArea = ({ lat, lng }) => (dispatch, getState) => {
  const state = getState();
  const pins = getHomeMapPins(state);
  return dispatch({
    type: TRACK_TAPPED_SEARCH_THIS_AREA,
    payload: {
      name: 'Tapped search this area',
      properties: {
        'Number of restaurants': pins.length,
        'Search lat': lat,
        'Search long': lng,
      },
    },
  });
};
